import { render, staticRenderFns } from "./ALFStatus.vue?vue&type=template&id=0cd6a8bc"
import script from "./ALFStatus.vue?vue&type=script&lang=js"
export * from "./ALFStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports